import { render, staticRenderFns } from "./filterTags.vue?vue&type=template&id=745d16a4&scoped=true&"
import script from "./filterTags.vue?vue&type=script&lang=js&"
export * from "./filterTags.vue?vue&type=script&lang=js&"
import style0 from "./filterTags.vue?vue&type=style&index=0&id=745d16a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d16a4",
  null
  
)

export default component.exports